import { EconomyCard } from './economy-card.component';
import { ECONOMY_VALUE_CLASS } from '../economy-theme';

export interface EconomyCardLoadErrorProps {
  /** The card's own title, so the section stays identifiable while its content is unavailable. */
  title: string;
  /** The card's own translated message. Each card names what failed to load. */
  message: string;
}

/**
 * What a self-fetching Innstillinger card renders when its request fails.
 *
 * Extracted after review on PR #625: four cards — Konsern-nivå, Konsern-konti and the two chart
 * cards — repeated this markup verbatim, so a change to how a failed load looks had to be made in
 * four places.
 *
 * Deliberately **not** `rowStack`, and that is the one thing to keep in mind if this is ever
 * extended. Inside a rowStack card the content area is a three-column grid, so a bare child lands
 * in the label column and reads as a truncated field rather than as the card's whole state.
 *
 * The loading states are **not** extracted with it: they genuinely differ. Konsern-nivå renders one
 * skeleton per row inside a rowStack, Konsern-konti renders a fixed number of full-width rows, and
 * the chart cards render a single line. Forcing them into one component would mean a prop for each
 * difference, which is more coupling than the duplication it removes.
 */
export function EconomyCardLoadError({ title, message }: EconomyCardLoadErrorProps) {
  return (
    <EconomyCard title={title}>
      <span className={ECONOMY_VALUE_CLASS}>{message}</span>
    </EconomyCard>
  );
}

export default EconomyCardLoadError;
